import React from 'react';
import { Link } from 'react-router-dom';
import IsAuthorized from '../services/authentication/IsAuthorized';
import { useFeatureFlag } from '../services/featureFlags';

const Reports = () => {
  const { hasFeatureFlag, loading: loadingFeatureFlag } = useFeatureFlag();

  return (
    <div className="settings-page">
      <div className="settings-links">
        <IsAuthorized>
          <Link className="link" to={'/defaultValveExerciseSettings'}>Default Valve Settings</Link>
          <Link className="link" to={'/defaultHydrantExerciseSettings'}>Default Hydrant Settings</Link>
          <Link className="link" to={'/hydrantManufacturers'}>Hydrant Manufacturers</Link>
          <Link className="link" to={'/hydrantModels'}>Hydrant Models</Link>
          {hasFeatureFlag('fireFlow') && <Link className="link" to={'/flowDevices'}>Flow Devices</Link>}
          <Link className="link" to={'/users'}>Users</Link>
        </IsAuthorized>
      </div>
    </div>
  );
};

export default Reports;